const Salutation = Object.freeze({
    MS: 'MS',
    MR: 'MR'
});
export { Salutation }